/*
 * @Author: yzr
 * @Date: 2021-07-19 11:30:43
 * @Last Modified by: yzr
 * @Last Modified time: 2021-07-19 15:07:37
 */
import Modules from './modules.vue';

export default Modules;
